import '../../../../../util/styles/index.js';
import { useListBoxSection } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

var useSelectionListSection = function useSelectionListSection(props) {
  var _useReactAriaListBoxS = useListBoxSection(props),
    itemProps = _useReactAriaListBoxS.itemProps,
    groupProps = _useReactAriaListBoxS.groupProps;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var groupStyle = mapAdsStyles({
    p: '0',
    listStyle: 'none'
  });
  return {
    itemProps: itemProps,
    groupProps: mergeProps(groupProps, groupStyle)
  };
};

export { useSelectionListSection };
//# sourceMappingURL=useSelectionListSection.js.map
